export const DOMAIN_URL = 'api/v1/user/domain/'
export const GET_DOMAINS_RENEW = 'api/v1/user/domain/prices/renew'
